import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import { ConnectedRouter } from "connected-react-router";
import appHistory from "./app/appHistory";
import appStore from "./app/appStore";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './fonts/fonts.css';

ReactDOM.render(
    <Provider store={appStore}>
        <ConnectedRouter history={appHistory}>
            <React.StrictMode>
                <App/>
            </React.StrictMode>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);
